import React,{useState} from 'react'
import Footer from '../inc/Footer'
import { FaLocationDot,FaEnvelope,FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import "../inc/GlobalVars";
function ContactUs() {
    const iconsStyles =
    {
        backgroundColor:"#fff",
        padding:"10px 12px",
        borderRadius:"50px",
        color:"#000",
        width:"10%"
    }
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        mobile: "",
        subject: "",
        message: "",
      });

      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
    
        try {
          const response = await axios.post(global.apiUrl +"/submitContact", formData);
            console.log("response"+response.status);
          if (response.status === 200) {
            // Show success toastr with the user's name
            toast.success(`Thank you ${formData.fullName} for contacting us!. We will contact you on ${formData.mobile}`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
            });
    
            // Reset the form
            setFormData({
              fullName: "",
              email: "",
              mobile: "",
              subject: "",
              message: "",
            });
          } else {
            toast.error("Failed to submit your query. Please try again.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              theme: "colored",
            });
          }
        } catch (error) {
          console.error(error);
          toast.error("An error occurred. Please try again later.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
          });
        }
      };
  return (
    <div className=''>
        <ToastContainer
        position="top-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        />
        <div className='container contact-container mb-5 ps-5 pe-5'>
            <div className='row d-flex justify-content-center position-relative'>
                <div className='col-md-5'>
                   <h2 className='text-white pt-5 '>Contact Us</h2>
                    <ul className='pt-3'>
                        <li className='mb-3'>
                            <div className='d-flex align-items-center'>
                                <span style={iconsStyles} className='d-flex align-items-center justify-content-center'>
                                    <FaEnvelope style={{fontSize:"22px"}} />
                                </span>
                                <span className='ps-1 text-white'>
                                    contact@indussparebazaar.in
                                </span>
                            </div>
                        </li>
                        <li className='mb-3'>
                            <div className='d-flex align-items-center'>
                                <span style={iconsStyles} className='d-flex align-items-center justify-content-center'>
                                    <FaPhoneAlt style={{fontSize:"22px"}} />
                                </span>
                                <span className='ps-1 text-white'>
                                +91 8222977001/003/004
                                </span>
                            </div>
                        </li>
                        <li className='mb-3'>
                            <div className='d-flex align-items-center'>
                                <span style={iconsStyles} className='d-flex align-items-center justify-content-center'>
                                    <FaMapMarkerAlt style={{fontSize:"22px"}} />
                                </span>
                                <span className='ps-1 text-white'>
                                809-A, 8th floor, Welldone Tech Park, Sector 48, Gurugram, Haryana 122018
                                </span>
                            </div>
                        </li>
                    </ul>

                    <img src={window.location.origin + '/images/aboutcar.png'} className="img-fluid position-absolute contact-car" />
                </div>
                <div className='col-md-7'>
                    
                    <div className='contactBox ps-5 pe-5'>
                    <h4>Please Fill Up The Form</h4><hr/>
                    <form onSubmit={handleSubmit}>
      <div className="mb-2">
        <label>
          Full Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="fullName"
          value={formData.fullName}
          onChange={handleInputChange}
          placeholder="Your Full Name"
          required
        />
      </div>
      <div className="mb-2">
        <label>
          Email ID <span className="text-danger">*</span>
        </label>
        <input
          type="email"
          className="form-control"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          placeholder="Your Email ID"
          required
        />
      </div>
      <div className="mb-2">
        <label>
          Mobile Number <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="mobile"
          value={formData.mobile}
          onChange={handleInputChange}
          placeholder="Your Mobile Number"
          required
        />
      </div>
      <div className="mb-2">
        <label>
          Subject <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          name="subject"
          value={formData.subject}
          onChange={handleInputChange}
          placeholder="Subject"
          required
        />
      </div>
      <div className="mb-3">
        <label>
          Message <span className="text-danger">*</span>
        </label>
        <textarea
          className="form-control"
          name="message"
          rows="3"
          value={formData.message}
          onChange={handleInputChange}
          placeholder="Your Message"
          required
        ></textarea>
      </div>
      <button className="btn btn-primary contactButton" type="submit">
        Submit Query
      </button>
    </form>
                    </div>
                </div>
            </div>
           
        </div>
        <div className='container mb-3'>
        <div className='row'>
                <div className='col-md-12'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3509.019318335617!2d77.03346127344808!3d28.418673940257005!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d23ac952fe5ed%3A0x2d354a104d995c73!2sWelldone%20Techpark!5e0!3m2!1sen!2sin!4v1700105521105!5m2!1sen!2sin" width="100%" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                </div>
            </div>
        </div>
        <Footer/>
    </div>
  )
}

export default ContactUs